import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import whobanner from "../img/contact.png";
import worldmap from "../img/worldmap.png";

import { Mail, Phone, MapPin } from 'lucide-react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

// ✅ Country config for dropdown, flags, dialing codes & (optional) phone patterns
const COUNTRIES = [
  {
    code: 'IN',
    name: 'India',
    dialCode: '+91',
    flag: '🇮🇳',
    // Indian mobile numbers: 10 digits, starting 6–9
    phonePattern: /^[6-9]\d{9}$/,
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    dialCode: '+44',
    flag: '🇬🇧',
    // Simplified: 10–11 digits
    phonePattern: /^\d{10,11}$/,
  },
  {
    code: 'US',
    name: 'United States',
    dialCode: '+1',
    flag: '🇺🇸',
    phonePattern: /^\d{10}$/,
  },

  // 👇 Extra common countries (no strict pattern => generic length validation used)
  { code: 'AF', name: 'Afghanistan', dialCode: '+93', flag: '🇦🇫' },
  { code: 'AL', name: 'Albania', dialCode: '+355', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', dialCode: '+213', flag: '🇩🇿' },
  { code: 'AD', name: 'Andorra', dialCode: '+376', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', dialCode: '+244', flag: '🇦🇴' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'AM', name: 'Armenia', dialCode: '+374', flag: '🇦🇲' },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'AZ', name: 'Azerbaijan', dialCode: '+994', flag: '🇦🇿' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'BE', name: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
  { code: 'BT', name: 'Bhutan', dialCode: '+975', flag: '🇧🇹' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', dialCode: '+267', flag: '🇧🇼' },
  { code: 'BR', name: 'Brazil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
  { code: 'KH', name: 'Cambodia', dialCode: '+855', flag: '🇰🇭' },
  { code: 'CM', name: 'Cameroon', dialCode: '+237', flag: '🇨🇲' },
  { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'HR', name: 'Croatia', dialCode: '+385', flag: '🇭🇷' },
  { code: 'CY', name: 'Cyprus', dialCode: '+357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿' },
  { code: 'DK', name: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
  { code: 'DO', name: 'Dominican Republic', dialCode: '+1', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'EG', name: 'Egypt', dialCode: '+20', flag: '🇪🇬' },
  { code: 'EE', name: 'Estonia', dialCode: '+372', flag: '🇪🇪' },
  { code: 'ET', name: 'Ethiopia', dialCode: '+251', flag: '🇪🇹' },
  { code: 'FI', name: 'Finland', dialCode: '+358', flag: '🇫🇮' },
  { code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'GR', name: 'Greece', dialCode: '+30', flag: '🇬🇷' },
  { code: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰' },
  { code: 'HU', name: 'Hungary', dialCode: '+36', flag: '🇭🇺' },
  { code: 'IS', name: 'Iceland', dialCode: '+354', flag: '🇮🇸' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'IR', name: 'Iran', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IE', name: 'Ireland', dialCode: '+353', flag: '🇮🇪' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'IT', name: 'Italy', dialCode: '+39', flag: '🇮🇹' },
  { code: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  { code: 'JO', name: 'Jordan', dialCode: '+962', flag: '🇯🇴' },
  { code: 'KE', name: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'LV', name: 'Latvia', dialCode: '+371', flag: '🇱🇻' },
  { code: 'LB', name: 'Lebanon', dialCode: '+961', flag: '🇱🇧' },
  { code: 'LT', name: 'Lithuania', dialCode: '+370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', dialCode: '+352', flag: '🇱🇺' },
  { code: 'MY', name: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'MV', name: 'Maldives', dialCode: '+960', flag: '🇲🇻' },
  { code: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  { code: 'MX', name: 'Mexico', dialCode: '+52', flag: '🇲🇽' },
  { code: 'MA', name: 'Morocco', dialCode: '+212', flag: '🇲🇦' },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { code: 'NL', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  { code: 'NZ', name: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'NO', name: 'Norway', dialCode: '+47', flag: '🇳🇴' },
  { code: 'OM', name: 'Oman', dialCode: '+968', flag: '🇴🇲' },
  { code: 'PK', name: 'Pakistan', dialCode: '+92', flag: '🇵🇰' },
  { code: 'PA', name: 'Panama', dialCode: '+507', flag: '🇵🇦' },
  { code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  { code: 'PH', name: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', dialCode: '+48', flag: '🇵🇱' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'QA', name: 'Qatar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'RO', name: 'Romania', dialCode: '+40', flag: '🇷🇴' },
  { code: 'RU', name: 'Russia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'SA', name: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { code: 'RS', name: 'Serbia', dialCode: '+381', flag: '🇷🇸' },
  { code: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'SK', name: 'Slovakia', dialCode: '+421', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovenia', dialCode: '+386', flag: '🇸🇮' },
  { code: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { code: 'KR', name: 'South Korea', dialCode: '+82', flag: '🇰🇷' },
  { code: 'ES', name: 'Spain', dialCode: '+34', flag: '🇪🇸' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'SE', name: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  { code: 'CH', name: 'Switzerland', dialCode: '+41', flag: '🇨🇭' },
  { code: 'TW', name: 'Taiwan', dialCode: '+886', flag: '🇹🇼' },
  { code: 'TH', name: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  { code: 'TR', name: 'Turkey', dialCode: '+90', flag: '🇹🇷' },
  { code: 'UA', name: 'Ukraine', dialCode: '+380', flag: '🇺🇦' },
  { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', dialCode: '+998', flag: '🇺🇿' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'YE', name: 'Yemen', dialCode: '+967', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', dialCode: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', dialCode: '+263', flag: '🇿🇼' },
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    // track both ISO country + dial code; default India
    country: 'IN',
    countrycode: '+91',
    phone: '',
    location: '',
    purpose: '',
    message: '',
  });

  const [formMessage, setFormMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // inline validation error for phone
  const [phoneError, setPhoneError] = useState('');
  // field-wise error messages
  const [errors, setErrors] = useState({});

  // helper to get currently selected country object
  const selectedCountry =
    COUNTRIES.find(c => c.code === formData.country) || COUNTRIES[0];

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true, easing: 'ease-in-out' });

    const handleScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // phone + country have special handlers below
    if (name === 'phone' || name === 'country') return;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' })); // clear field error on change
  };

  // change country (dropdown)
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const country = COUNTRIES.find(c => c.code === countryCode);

    setFormData(prev => ({
      ...prev,
      country: countryCode,
      countrycode: country?.dialCode || prev.countrycode,
    }));

    // re-validate phone when country changes (only if user typed something)
    if (formData.phone) {
      validatePhone(formData.phone, country);
    }
  };

  // phone validation logic, per country
  const validatePhone = (value, country = selectedCountry) => {
    const digits = value.replace(/\D/g, '');

    if (!digits) {
      setPhoneError('Phone number is required.');
      setErrors(prev => ({ ...prev, phone: 'Phone number is required.' }));
      return false;
    }

    // If we have a specific pattern for country, use it
    if (country?.phonePattern && !country.phonePattern.test(digits)) {
      const msg = `Please enter a valid ${country.name} mobile number.`;
      setPhoneError(msg);
      setErrors(prev => ({ ...prev, phone: msg }));
      return false;
    }

    // Generic validation for countries without explicit pattern
    const min = 6;
    const max = 15;
    if (digits.length < min || digits.length > max) {
      const msg = `Please enter a valid ${country.name} phone number (${min}-${max} digits).`;
      setPhoneError(msg);
      setErrors(prev => ({ ...prev, phone: msg }));
      return false;
    }

    setPhoneError('');
    setErrors(prev => ({ ...prev, phone: '' }));
    return true;
  };

  // phone change handler (combined UI)
  const handlePhoneChange = (e) => {
    const { value } = e.target;
    // allow digits + basic formatting chars
    const cleaned = value.replace(/[^\d\s\-()+]/g, '');
    setFormData(prev => ({ ...prev, phone: cleaned }));
    validatePhone(cleaned);
  };

  const safeStringify = (v, max = 1200) => {
    try {
      const s = typeof v === 'string' ? v : JSON.stringify(v, null, 2);
      return s.length > max ? s.slice(0, max) + '...' : s;
    } catch {
      return String(v);
    }
  };

  // validate all required fields
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required.';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    if (!formData.location.trim()) {
      newErrors.location = 'Location is required.';
    }

    if (!formData.purpose.trim()) {
      newErrors.purpose = 'Please select a purpose.';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage('');
    setIsSubmitting(true);

    const formIsValid = validateForm();
    const phoneIsValid = validatePhone(formData.phone);

    if (!formIsValid || !phoneIsValid) {
      setFormMessage('Please correct the highlighted fields before submitting.');
      setIsSubmitting(false);
      return;
    }

    // build E.164 phone value
    const numericPhone = formData.phone.replace(/\D/g, '');
    const e164Phone = `${selectedCountry.dialCode}${numericPhone}`;

    const payload = {
      name: formData.name,
      email: formData.email,
      country_code: selectedCountry.dialCode, // keep country code
      phoneno: e164Phone,                     // send E.164 format
      location: formData.location,
      purpose: formData.purpose,
      message: formData.message,
    };

    try {
      const response = await axios.post(
        'https://api.securxperts.com:8000/forms/contact',
        payload,
        {
          headers: { 'Content-Type': 'application/json' },
          timeout: 15000,
          validateStatus: () => true,
        }
      );

      const rawMessage =
        response?.data?.message ??
        response?.data?.detail ??
        response?.data?.error ??
        '';

      // treat "success" messages as success instead of failure
      const isSuccessResponse =
        response?.data?.success === true ||
        (response.status >= 200 &&
          response.status < 300 &&
          /success/i.test(String(rawMessage)));

      if (isSuccessResponse) {
        setFormMessage(
          rawMessage || 'Your message has been sent successfully! Redirecting...'
        );

        // reset form
        setFormData({
          name: '',
          email: '',
          country: 'IN',
          countrycode: '+91',
          phone: '',
          location: '',
          purpose: '',
          message: '',
        });
        setPhoneError('');
        setErrors({});

        // redirect so that page "refreshes" & is clean
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      } else {
        const serverMsg =
          rawMessage || response.data || 'Something went wrong. Please try again.';
        setFormMessage(`Failed: ${safeStringify(serverMsg)}`);
      }
    } catch (err) {
      setFormMessage(`Error: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />

      {/* HERO */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/40 lg:bg-black/10" />

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Contact
            </h1>

            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">Home</Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              ></svg>
              <span>Contact</span>
            </div>
          </div>
        </div>
      </header>

      {/* CONTACT BODY */}
      <section className="py-20 bg-fixed bg-cover bg-center">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden flex flex-col lg:flex-row">

            {/* LEFT PANEL */}
            <div className="bg-[#1b1b1b] text-white p-8 md:p-12 lg:w-5/12 xl:w-4/12 flex flex-col justify-between">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-2">Contact Information</h2>
                <p className="text-gray-400 text-lg mb-8">We’re here to assist you.</p>

                {/* WORLD MAP WITH PINNED LOCATIONS */}
                <div className="w-full mb-10">
                  <div className="relative w-full h-56 md:h-72 lg:h-80 rounded-lg overflow-hidden shadow-xl bg-black">
                    <img
                      src={worldmap}
                      alt="World Map"
                      className="w-full h-full object-cover opacity-40"
                      draggable="false"
                    />

                    {/* INDIA / HYDERABAD PIN */}
                    <div
                      className="absolute w-5 h-5 bg-red-500 rounded-full animate-ping"
                      style={{ top: "49%", left: "72%" }}
                    />
                    <div
                      className="absolute w-3 h-3 bg-red-600 rounded-full"
                      style={{ top: "49%", left: "72%" }}
                    />
                    <div className="absolute text-xs text-white left-[70%] top-[53%]">
                      🇮🇳 Hyderabad, India
                    </div>

                    {/* UK PIN */}
                    <div
                      className="absolute w-5 h-5 bg-blue-500 rounded-full animate-ping"
                      style={{ top: "35%", left: "40%" }}
                    />
                    <div
                      className="absolute w-3 h-3 bg-blue-700 rounded-full"
                      style={{ top: "35%", left: "40%" }}
                    />
                    <div className="absolute text-xs text-white left-[44%] top-[34%]">
                      🇬🇧 United Kingdom
                    </div>
                  </div>
                </div>

                {/* CONTACT DETAILS */}
                <div className="space-y-6">
                  <div className="flex items-start">
                    <Phone className="w-5 h-5 text-indigo-400 mr-4 mt-1" />
                    <span className="text-lg">+91 79932 56679</span>
                  </div>

                  <div className="flex items-start">
                    <Mail className="w-5 h-5 text-indigo-400 mr-4 mt-1" />
                    <span className="text-lg">info@SecurXperts.com</span>
                  </div>

                  <div className="flex items-start">
                    <MapPin className="w-5 h-5 text-indigo-400 mr-4 mt-1" />
                    <span className="text-lg">
                      <strong>India Office:</strong><br />
                      5th Floor, Krishna Towers, Madhapur,<br />
                      Hyderabad, Telangana 500081
                    </span>
                  </div>

                  <div className="flex items-start pt-4 border-t border-gray-700">
                    <MapPin className="w-5 h-5 text-indigo-400 mr-4 mt-1" />
                    <span className="text-lg">
                      <strong>UK Office:</strong><br />
                      194 Gulson Road,<br />
                      Coventry, England, CV1 2JD<br />
                      United Kingdom
                    </span>
                  </div>
                </div>

                {/* SOCIALS */}
                <div className="mt-12 flex space-x-4">
                  {[
                    { Icon: FaFacebookF, url: 'https://www.facebook.com/profile.php?id=61576099186187' },
                    { Icon: FaInstagram, url: 'https://www.instagram.com/securxpert' },
                    { Icon: FaLinkedinIn, url: 'https://www.linkedin.com/company/securxpert-technologies-pvt-ltd/posts/?feedView=all' },
                    { Icon: FaYoutube, url: 'https://www.youtube.com/@SecurXpert' },
                  ].map(({ Icon, url }, index) => (
                    <a
                      key={index}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-500 hover:border-white hover:bg-white transition-all"
                    >
                      <Icon className="w-4 h-4 text-gray-300 hover:text-indigo-700 transition" />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="p-8 md:p-12 lg:w-7/12 xl:w-8/12 bg-white">
              {formMessage && (
                <div
                  className={`mb-6 p-4 text-center rounded font-medium text-sm ${
                    /success/i.test(formMessage)
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {formMessage}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-10">
                {/* Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Full Name *"
                    className="w-full border-0 border-b-2 border-gray-300 focus:border-indigo-600 pb-3 text-lg bg-transparent outline-none"
                    required
                  />
                  {errors.name && (
                    <p className="mt-1 text-sm text-red-600">{errors.name}</p>
                  )}
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address *"
                    className="w-full border-0 border-b-2 border-gray-300 focus:border-indigo-600 pb-3 text-lg bg-transparent outline-none"
                    required
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                  )}
                </div>

                {/* Combined country code + phone into one UI */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>

                  <div className="flex flex-col md:flex-row gap-4">
                    {/* Country dropdown with flags + dial code */}
                    <div className="md:w-1/2">
                      <div className="w-full border-0 border-b-2 border-gray-300 focus-within:border-indigo-600 pb-3 flex items-center">
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleCountryChange}
                          className="w-full bg-transparent outline-none text-lg"
                        >
                          {COUNTRIES.map(country => (
                            <option key={country.code} value={country.code}>
                              {country.flag} {country.name} ({country.dialCode})
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Phone input with dial code text, E.164-ready */}
                    <div className="md:flex-1">
                      <div className="w-full border-0 border-b-2 border-gray-300 focus-within:border-indigo-600 pb-3 flex items-center">
                        <span className="mr-2 text-lg text-gray-700">
                          {selectedCountry.dialCode}
                        </span>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handlePhoneChange}
                          placeholder="Phone Number *"
                          className="w-full bg-transparent outline-none text-lg"
                          required
                        />
                      </div>
                      {(phoneError || errors.phone) && (
                        <p className="mt-1 text-sm text-red-600">
                          {phoneError || errors.phone}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Location */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Location</label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="City, Country *"
                    className="w-full border-0 border-b-2 border-gray-300 focus:border-indigo-600 pb-3 text-lg bg-transparent outline-none"
                    required
                  />
                  {errors.location && (
                    <p className="mt-1 text-sm text-red-600">{errors.location}</p>
                  )}
                </div>

                {/* Purpose */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Purpose</label>
                  <select
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleChange}
                    className="w-full border-0 border-b-2 border-gray-300 focus:border-indigo-600 pb-3 text-lg bg-transparent outline-none"
                    required
                  >
                    <option value="">-- Select Purpose * --</option>
                    <option value="Inquiry">Inquiry</option>
                    <option value="Support">Support</option>
                    <option value="Feedback">Feedback</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.purpose && (
                    <p className="mt-1 text-sm text-red-600">{errors.purpose}</p>
                  )}
                </div>

                {/* Message */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <textarea
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here *"
                    className="w-full border-0 border-b-2 border-gray-300 focus:border-indigo-600 pb-3 text-lg bg-transparent resize-none outline-none"
                    required
                  />
                  {errors.message && (
                    <p className="mt-1 text-sm text-red-600">{errors.message}</p>
                  )}
                </div>

                <div className="text-right pt-6">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-indigo-950 hover:bg-indigo-800 text-white font-bold py-4 px-12 rounded-lg shadow-lg transition-all duration-300"
                  >
                    {isSubmitting ? 'Sending...' : 'Submit'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - (307.919 * scrollProgress) / 100}
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/200/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Contact;
